module.exports = __webpack_public_path__ + "img/Chad.db35cd99.gif";